import axios from 'axios'
import pageKeys from '../common/pagekeys'
import store from '@/store'

export default {
    async get() {
        try
        {            
            const response = await axios.get(`Team`, {
                headers: {
                    'page_key': pageKeys.teams
                }
            })                        
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    async getByTeamId(teamId) {
        try
        {            
            const response = await axios.get(`Team/${teamId}`, {
                headers: {
                    'page_key': pageKeys.teams
                }
            })                      
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    async getTeamsByCompany(includeMembers) {
        try
        {            
            const response = await axios.get(`Team/bycompany/${includeMembers}`, {
                headers: {
                    'page_key': pageKeys.teams
                }
            })                       
            return response
        }
        catch (error)
        {
            console.log('getTeamsByCompany error')
            throw error
        }
    },
    async getMembersByUser() {
        try
        {            
            const response = await axios.get(`Team/members/byuserid`, {
                headers: {
                    'page_key': pageKeys.teams
                }
            })                        
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    async getApprovers(teamId) {
        try
        {            
            const response = await axios.get(`Team/approvers/${teamId}`, {
                headers: {
                    'page_key': pageKeys.teams
                }
            })                        
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    async getMembersByTeam() {
        try
        {           
            //used in getTeamMembers in main page left nav
            //used in myteam > workshifts assignment
            const response = await axios.get(`Team/members/byteamid`)            
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    async getTodaysStatusByTeam(teamId) {
        try
        {            
            const response = await axios.get(`Team/${teamId}/status/today`,
            {
                headers: {
                    'page_key': pageKeys.team_attendance
                }
            })                                                            
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    async getTeamStatusByDate(teamId, transDate) {
        try
        {            
            const response = await axios.get(`Team/${teamId}/status/${transDate}`,
            {
                headers: {
                    'page_key': pageKeys.team_attendance
                }
            })                                                
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    async getTeamStatusWeekly(data) {
        try
        {            
            const response = await axios.get(`Team/${data.teamId}/status/${data.fiscalYear}/${data.weekNo}`,
            {
                headers: {
                    'page_key': pageKeys.team_attendance
                }
            })                                                
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    async getTeamStatusWeeklyExcel(data) {
        try{            
            const response = await axios.get(`Team/${data.teamId}/status/xls/${data.fiscalYear}/${data.weekNo}`,
            {
                responseType: 'arraybuffer',
                headers: {
                    'page_key': pageKeys.team_attendance
                }
            })            
            return response
        }
        catch (error)
        {
            console.log('Team api getTeamStatusWeeklyExcel error')
            throw error
        }
    },
    async getBirthdays() {
        try
        {            
            const response = await axios.get(`Team/members/birthdays`)            
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    async getMembersBySelectedTeam(teamId) {
        try
        {           
            //Used in User Profile > Edit Team > Get Approvers
            const response = await axios.get(`Team/members/byteamid/${teamId}`,{
                headers: {
                    'page_key': pageKeys.teams
                }
            })             
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    // turned off
    // async getTeamEvents() {
    //     try
    //     {            
    //         const response = await axios.get(`Team/events/byteam`)            
    //         return response
    //     }
    //     catch (error)
    //     {
    //         throw error
    //     }
    // },
    async getTeamEventsByMonth(currentDate) {
        try
        {            
            const response = await axios.get(`Team/${store.state.selectedTeamId}/events/${currentDate}`,
            {
                headers: {
                    'page_key': pageKeys.team_calendar //Team Calendar	/myteam/calendar
                }
            })                                                           
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    async getTeamEventsByMonthStartingToday() {
        try
        {            
            const response = await axios.get(`Team/${store.state.selectedTeamId}/events/today`)                                                           
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    async upsert(teamId, teamName, description, teamLogo) {       
        try {            
            const data = {
                teamId: teamId,
                name: teamName,
                description: description,
                logoFileName: teamLogo
            }

            const response = await axios.post(`Team`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.teams    // Teams	Teams, Employees	/teams
                }
            }) 
            return response
        } catch (error) {
            throw error
        }
    },
    async upsertMembership(data) {       
        try { 
            const response = await axios.post(`Team/membership`, {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.employees //used in UserProfile > Team Membership
                }
            })
            return response
        } catch (error) {
            throw error
        }
    },
    async deleteMembership(teamMemberId) {       
        try { 
            const response = await axios.post(`Team/membership/delete/${teamMemberId}`, {},
            {
                headers: {
                    'page_key': pageKeys.employees //used in UserProfile > Team Membership
                }
            })
            return response
        } catch (error) {
            throw error
        }
    },
    async reAssignMember(userId, teamId, role, supervisorId) {       
        try
        {            
            const data = {
                userId: userId,
                teamId: teamId,
                role: role,
                supervisorId: supervisorId
            }

            const response = await axios.post(`Team/member/reassign`, {
                item: data
            }, 
            {
                headers: {
                    'page_key': pageKeys.teams
                }
            })                                    
            
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    async getMyTeams() {
        try {           
            const response = await axios.get(`Team/myteams`,{
                headers: {
                    'page_key': pageKeys.teams
                }
            })             
            return response
        }
        catch (error)
        {
            throw error
        }
    },
}